<full-header-slider class="block relative w-full lg:mt-[-86px]">
  <div class="container lg:pt-[215px] w-full pb-8 flex flex-col items-center text-white">
    <h1 class="text-4xl mt-2 place-self-start">Expometals Insider</h1>
    <h3 class="text-2xl place-self-start" i18n="news editorial subtitle">Directly from inside the industry: news, trends, and insights from our editorial team</h3>
  </div>
</full-header-slider>